import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, map } from 'rxjs';
import { AppModeService } from 'src/app/services/app-mode.service';
import { CartItem, CartService } from 'src/app/services/cart/cart.service';

@Component({
  selector: 'app-cart-page',
  templateUrl: './cart-page.component.html',
  styleUrls: ['./cart-page.component.css'],
})
export class CartPageComponent {
  readonly items$ = this.cartService.items$;
  readonly discount$ = this.cartService.discount$;
  readonly subtotal$ = this.cartService.total$;
  readonly totalToPay$ = combineLatest([this.subtotal$, this.discount$]).pipe(
    map(([subtotal, discount]) => Math.max(0, subtotal - discount)),
  );

  constructor(
    private readonly router: Router,
    public readonly appModeService: AppModeService,
    private readonly cartService: CartService,
  ) {}

  goBack(): void {
    const lang = localStorage.getItem('lang') || 'en';
    this.router.navigateByUrl(`/${lang}/home`);
  }

  incrementQuantity(item: CartItem): void {
    this.cartService.incrementQuantity(item.id);
  }

  decrementQuantity(item: CartItem): void {
    this.cartService.decrementQuantity(item.id);
  }

  removeItem(item: CartItem): void {
    this.cartService.removeItem(item.id);
  }

  addToFavorite(_: CartItem): void {}

  continueShopping(): void {
    const lang = localStorage.getItem('lang') || 'en';
    this.router.navigateByUrl(`/${lang}/products`);
  }

  onCheckout(): void {
    this.router.navigateByUrl('/checkout');
  }

  trackByItem(_: number, item: CartItem): string {
    return item.id;
  }
  get isRTL(): boolean {
    return document.documentElement.dir === 'rtl';
  }
}
